import { SITE } from "../data/site";
import { MapPin, Clock, ArrowUpRight } from "lucide-react";

const STORES = [
  {
    name: "Triple J Bali — Canggu Store",
    short: "Canggu",
    image: "/images/store/triple-j-bali-canggu-store-exterior-01.webp",
    detail: "/images/store/triple-j-bali-canggu-store-detail-01.webp",
    maps: SITE.cangguMaps,
    test: "canggu",
  },
  {
    name: "Triple J Bali — Ubud Store",
    short: "Ubud",
    image: "/images/store/triple-j-bali-ubud-store-exterior-01.webp",
    detail: "/images/store/triple-j-bali-ubud-store-interior-01.webp",
    maps: SITE.ubudMaps,
    test: "ubud",
  },
];

const StoreLocations = () => (
  <section
    id="locations"
    data-testid="store-locations"
    className="py-20 md:py-28 bg-[hsl(var(--background))]"
  >
    <div className="container-tjb">
      <div className="max-w-2xl mb-12">
        <p className="eyebrow">Visit Us</p>
        <h2 className="h-section mt-3">Visit Triple J Bali in Canggu or Ubud</h2>
        <p className="mt-4 text-base md:text-lg text-[hsl(var(--ink))]/80 leading-relaxed">
          Find our linen-focused Bali clothing stores in two of the island’s
          most loved areas. Both stores are open daily from 9 AM to 9 PM. Choose
          your nearest location and open it directly on Google Maps.
        </p>
      </div>

      <div className="grid md:grid-cols-2 gap-6 md:gap-8">
        {STORES.map((s) => (
          <a
            key={s.test}
            href={s.maps}
            target="_blank"
            rel="noopener noreferrer"
            data-testid={`store-card-${s.test}`}
            className="store-card group relative overflow-hidden bg-[hsl(var(--sand))]"
          >
            <div className="aspect-[4/5] md:aspect-[4/4.4] relative">
              <img
                src={s.image}
                alt={s.name}
                loading="lazy"
                className="w-full h-full object-cover transition-transform duration-[1400ms] group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/65 via-black/15 to-transparent" />
              <div className="absolute inset-0 p-7 md:p-10 flex flex-col justify-end text-[hsl(var(--cream))]">
                <p className="eyebrow !text-[hsl(var(--cream))]/85">{s.short} Store</p>
                <h3 className="font-display text-2xl md:text-3xl mt-2">
                  {s.name}
                </h3>
                <div className="mt-4 flex items-center gap-2 text-sm">
                  <Clock className="w-4 h-4" />
                  <span>Open daily, 9 AM – 9 PM</span>
                </div>
                <span
                  data-testid={`store-maps-${s.test}`}
                  className="mt-6 inline-flex items-center gap-2 self-start btn-ghost-light"
                >
                  <MapPin className="w-4 h-4" />
                  Open {s.short} on Google Maps
                  <ArrowUpRight className="w-3.5 h-3.5" />
                </span>
              </div>
            </div>
          </a>
        ))}
      </div>
    </div>
  </section>
);

export default StoreLocations;
